import Ajax from 'Utils/ajax';
export const getDashboard = () => Ajax.post('admin/getDashboard');
export const calenderList = (data) => Ajax.post('hr/calenderList',data);
export const getToDoList = (data) => Ajax.post('hr/getToDoList',data);
export const getMessageList = (data) => Ajax.post('hr/getMessageList',data);
export const getAttendanceStats = (data) => Ajax.post('admin/getAttendanceStats',data);
export const getLeaveBalanceStats = (data) => Ajax.post('admin/getLeaveBalanceStats',data);
export const getAnnouncementList = (data) => Ajax.post('setting/getAnnouncementList',data);
